// extracted by mini-css-extract-plugin
export var cartButton = "cart-button-module--cartButton--m4LbS";
export var badge = "cart-button-module--badge--UKrhJ";